import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class SrcMappingTradeType {

  @JsonProperty()
  id: number;

  @JsonProperty()
  sourceCode: string | undefined;

  @JsonProperty()
  crystalExchangeCode: string | undefined;

  @JsonProperty()
  sourceTradeType: string | undefined;

  @JsonProperty()
  crystalTradeType: string | undefined;

  @JsonProperty()
  source: string | undefined;

  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

}
